import _ from 'underscore';
import cssUtil from 'gw-portals-util-js/CssUtil';

import Coverage from '../../models/Coverage';

import styles from './EditableCoverages-hashed.scss';
import template from 'text!./EditableCoverages.html';

export default [function () {
    return {
        restrict: 'E',
        template: cssUtil.hashTemplate(template, styles),
        scope: {
            coverages: '=',
            loading: '=',
            onCovChange: '=',
            allowSelectCoverage: '=',
            allCoveragesLoaded: '=?',
            dependentCoverages: '=',
            currentDependentCoverages: '=',
            listIndex: '=?'
            // no-loaders attribute if specified removes the loader
        },
        compile: function compile(tElement, tAttrs) {
            if ('noLoaders' in tAttrs) {
                $(tElement).find('[gw-loader]').removeAttr('gw-loader');
            }
        },
        controller: ['$scope', '$filter', function ($scope, $filter) {
            var dependentCoveragesMap = mapDependantCoverages($scope.dependentCoverages);

            $scope.select = function ($event, coverage) {
                if (!coverage.selected) {
                    // This handles the case when user clicks on a checkbox so that this callback and toggle don't counteract each other
                    $event.stopPropagation();
                    $event.preventDefault();

                    coverage.selected = true;
                }
            };

            $scope.toggle = function ($event, coverage) {
                $event.stopPropagation();
                coverage.selected = !coverage.selected;
            };

            $scope.turnOff = function ($event, coverage) {
                $event.stopPropagation();
                coverage.selected = false;
            };
            $scope.turnOn = function ($event, coverage) {
                $event.stopPropagation();
                coverage.selected = true;
            };

            $scope.ignoreClick = function ($event) {
                $event.stopPropagation();
            };

            $scope.shouldShowCheckbox = function (coverage) {
                return coverage.required || !$scope.allowSelectCoverage;
            };

            function isLoading() {
                return $scope.loading;
            }

            $scope.loadingSelectedCoverages = [];

            function updateSelectedCoverage(coverage) {
                $scope.loadingSelectedCoverages.push(coverage);
                $scope.onCovChange(coverage).finally(function () {
                    var covIndex = $scope.loadingSelectedCoverages.indexOf(coverage);
                    if (covIndex > -1) {
                        $scope.loadingSelectedCoverages.splice(covIndex, 1);
                    }
                });
            }

            function updateDependentCoverage(coverage, dependentCoverage) {
                $scope.currentDependentCoverages.push(dependentCoverage);
                $scope.onCovChange(coverage).finally(function () {
                    var covIndex = $scope.currentDependentCoverages.indexOf(dependentCoverage);
                    if (covIndex > -1) {
                        $scope.currentDependentCoverages.splice(covIndex, 1);
                    }
                });
            }

            function onChange(coverage, term) {
                // If the coverage has been selected, or all its terms are valid, perform a sync
                if (coverage.selectedChanged || coverage.terms && coverage.terms.length > 0 && _.every(coverage.terms, function (aTerm) {
                    return aTerm.aspects.valid;
                })) {
                    performOnChange(coverage, term);
                }
            }

            function mapDependantCoverages(dependantCoverages) {
                var coveragesMap = new Map();

                if (dependantCoverages) {
                    Object.keys(dependantCoverages).forEach(function (key) {
                        coveragesMap.set(dependantCoverages[key].name, true);
                    });
                }

                return coveragesMap;
            }

            function performOnChange(coverage, term) {
                var dependentCoverage = void 0;

                if ($scope.dependentCoverages) {
                    dependentCoverage = _.findWhere($scope.dependentCoverages, { name: coverage.publicID });

                    // If no dependent coverage is found, check dependent terms
                    if (!dependentCoverage && term) {
                        // Shallow clone the dependentCoverage term so we can change the name property without updating original object reference
                        dependentCoverage = _.clone(_.findWhere($scope.dependentCoverages, { name: term.type }));

                        if (dependentCoverage) {
                            dependentCoverage.name = term.coveragePublicID;
                        }
                    }
                }

                if ($scope.dependentCoverages && !dependentCoverage && coverage && coverage.hasTermPatterns && coverage.selected && coverage.selectedChanged) {
                    updateSelectedCoverage(coverage);
                } else if (dependentCoverage) {
                    updateDependentCoverage(coverage, dependentCoverage);
                } else if (!$scope.dependentCoverages) {
                    $scope.allCoveragesLoaded = false;
                    var onCovChange = typeof $scope.onCovChange === 'function' ? $scope.onCovChange() : null;
                    if (onCovChange) {
                        onCovChange.finally(function () {
                            $scope.allCoveragesLoaded = true;
                        });
                    }
                }

                // reset coverage selection check
                coverage.selectedChanged = false;
            }

            $scope.disableDependentCoverage = function (publicID) {
                if (!$scope.currentDependentCoverages || $scope.currentDependentCoverages.length === 0) {
                    return false;
                }

                return _.some($scope.currentDependentCoverages, function (cov) {
                    return _.some(cov.dependencies, function (dependent) {
                        return dependent === publicID;
                    });
                });
            };

            $scope.loadingCov = function (coverage) {
                return anyDependentCovsWithoutDeps() || !_.findWhere($scope.currentDependentCoverages, { name: coverage.publicID }) && !_.findWhere($scope.loadingSelectedCoverages, { publicID: coverage.publicID });
            };

            $scope.anyCoverageUpdating = function () {
                // If any dependent coverage does not have dependencies listed, show full loader
                return anyDependentCovsWithoutDeps() || !$scope.dependentCoverages && $scope.model.some(function (coverage) {
                    return coverage.updating || coverage.terms.some(function (term) {
                        return term.updating;
                    });
                });
            };

            function anyDependentCovsWithoutDeps() {
                return _.find($scope.currentDependentCoverages, function (depCov) {
                    return depCov.dependencies.length === 0;
                });
            }

            // Set up the model
            $scope.$watch('coverages', function (cov) {
                if (!cov) {
                    return;
                }

                $scope.model = _(cov).sortBy(function (coverage) {
                    return coverage.required ? -1 : 1;
                }).map(_.partial(Coverage.create, $filter('translate'), _, isLoading, onChange, $scope.disableDependentCoverage, dependentCoveragesMap)).valueOf();
            });

            $scope.getCoverageTypeAma = function (cov, term) {
                return term.valueType;
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/editablecoverages/EditableCoverages.js
// module id = 797
// module chunks = 0